import React from 'react';
import '../OfficesPage.scss'
import HrbTranslate from '../../../components/language/HrbTranslate';

const EmployeesQueueTableSortHeader = () => { 

    
    return (
        <div className="columns level">
            <div className='column is-8'>
                <h3 className='pt-4 pb-2 pl-2'>                    
                        <HrbTranslate text={'OfficesPage.Summary.TableTitle'} />                    
                </h3>
            </div>            
        </div>
    );
}

export default EmployeesQueueTableSortHeader